export type IConnection = {
    _id: string;
    userId: string;
    email: string;
    username: string;
    roles: string[];
    status: ConnectionStatus;
};

export type IConnectionRequest = {
    _id: string;
    senderId: string;
    senderEmail: string;
    receiverId: string;
    receiverEmail: string;
    status: ConnectionRequestStatus;
};

export enum ConnectionRequestType {
    SENT = 'SENT',
    RECEIVED = 'RECEIVED',
}

export enum ConnectionRequestStatus {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    DECLINED = 'DECLINED',
    CANCELED = 'CANCELED',
}

export enum ConnectionStatus {
    CONNECTED = 'CONNECTED',
    DISCONNECTED = 'DISCONNECTED',
}
